import MenuAside from './app/menu.aside'

function init()
{
    new MenuAside();
}

// page on ready
function onReady()
{
	init()
}

// composite data recieved
function onFrameDataReceived(json = {})
{
	if (!(json.dynamicBlocks || []).length)
	{
		return
	}

    init()
}

$(window).ready(onReady)
if (window.frameCacheVars !== undefined)
{
	BX.addCustomEvent("onFrameDataReceived", (json) => onFrameDataReceived(json))
}
